import EventsSelector from "./EventsSelector";

export default EventsSelector;